import React from "react";
import { useBarcode } from "next-barcode";
import "./OwBarcode.scss";

type Props = {
    format: "CODE128" | "UPC" | "EAN13";
    height?: number;
    value: string;
    /**
     * Remove the guard bars from the barcode
     */
    flat?: boolean;
    displayValue?: boolean;
};

export const OwBarcode = (props: Props) => {
    const { inputRef } = useBarcode({
        value: props.value,
        options: {
            height: props.height,
            format: props.format,
            flat: props.flat,
            displayValue: props.displayValue,
        },
    });

    return (
        <div className={"OwBarcode"}>
            <div className={"svg-container"}>
                <svg ref={inputRef} className={"responsive-svg"} />
            </div>
        </div>
    );
};
